import React from 'react';
import './css/SideBar.css';
import IconButton from '@material-ui/core/IconButton';
import HelpTip from './HelpTip';
import { Menu, Close } from '@material-ui/icons';

//do not delete for now
// const styles = {
//   paper: {
//     // background: "linear-gradient(45deg, #2196F3 30%, #21CBF3 90%)",
//     background: '#3182bd',
//     alignItems: 'center',
//   },
//   hide: {
//     display: 'none',
//   },
// };

export default class VisContainer extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      sidebarOpen: window.innerWidth >= 768
    }

    this.handleViewSidebar = this.handleViewSidebar.bind(this);
  }


  componentDidUpdate(prevProps) {
    const { open } = this.props;
    if ((open !== prevProps.open) && (open !== undefined)) { 
      this.handleOpenSidebar();
    }
  }

  handleOpenSidebar() {
    this.setState({
      sidebarOpen: true
    });
  }

  handleViewSidebar() {
    this.setState({
      sidebarOpen: !this.state.sidebarOpen
    });
  }

  render() {
    return (
      <div >
        <Header2
          open={this.state.sidebarOpen} 
          onClick={this.handleViewSidebar} 
          toggleSidebar={this.handleViewSidebar}
        />
        <div className='sideContainer'>
          <SideBar2 
            primary={this.props.primary} 
            isOpen={this.state.sidebarOpen} 
            toggleSidebar={this.handleViewSidebar}
          />
          <Content2 
            primary={this.props.secondary}
            isOpen={this.state.sidebarOpen}
          />
        </div>
      </div >
    );
  }
};

export class Header2 extends React.Component{
  render() {
    return (
      <header>
        
        <IconButton
          color="inherit"
          aria-label="open drawer"
          onClick={this.props.toggleSidebar}
        >
          {this.props.open ? <Close /> : <Menu />}
        </IconButton>
        <HelpTip 
        message={
          <div>
            Click the right-most icon to open and close the information sidebar. Filters, Downloads, and more information can be found within the sidebar.
            <br/><br/>
            Click a province to show the relevant data. Click multiple provinces to compare data across provinces. Click a selected province to de-select it.
            <br/><br/>
            Within the sidebar, you will find all the UNCRPD Articles that a Province meets. Click the Drop-Down next to an Article to see which programs meet this criteria. If two provinces are selected, it the drop-down will display whether the provinces selected meet the criteria for each article.
            <br/><br/>
            Click a Program to get more information about it in the Sidebar. 
            <br/><br/>
            Filters for the data can be found in the sidebar. Select from the provided options and use the slider to select a year range.
            <br/><br/>
            You may toggle the log scale view for the line chart to see the lower values using the toggle in the bottom right of the chart.
            <br/><br/>
            The downloads consist of: The Original Dataset gathered from various programs across Canada, The modified version of the data used for the visualizations on this page, and a spreadsheet showing the relevant data to the UNCRPD articles.
          </div>
        }
        placement="bottom-start"/>
      </header >
    );
  }
};

export class SideBar2 extends React.Component{
  render() {
    const sidebarClass = this.props.isOpen ? 'sidebar open' : 'sidebar';
    return (
      <div className={sidebarClass} >
        {this.props.primary}
      </div>
    );
  }
};

export class Content2 extends React.Component{
  render() {
    const contentClass = this.props.isOpen ? 'content open' : 'content';
    return (
      <div className={contentClass}>
        {this.props.primary}
      </div>
    );
  }
};
